import { toast } from "sonner";
import {
	CircleX,
	TriangleAlert,
	Info,
	CircleCheck,
	MessageCircle,
} from "lucide-react";
import { createElement } from "react";
import { Logger } from "./logger/Logger";

const backgroundColors = {
	error: "#ef4444",
	success: "#22c55e",
	warning: "#fb923c",
	info: "#3F96FD",
	message: "#9333ea",
};

const icons = {
	error: createElement(CircleX),
	success: createElement(CircleCheck),
	warning: createElement(TriangleAlert),
	info: createElement(Info),
	message: createElement(MessageCircle, { className: "w-5 h-5" }),
};

export const showNotification = ({
	message,
	type,
	duration,
	action,
	description,
	log,
}: {
	message: string;
	type: "error" | "success" | "info" | "warning" | "message";
	duration?: number;
	action?: {
		label: string;
		onClick: () => void;
		testId?: string;
	};
	description?: string;
	log?: {
		identifier: string;
	};
}) => {
	if (log) {
		Logger.error(message, {
			identifier: log.identifier,
		});
	}
	const textColor = type !== "success" ? "white" : "black";
	toast(message, {
		icon: icons[type],
		style: {
			backgroundColor: backgroundColors[type],
			color: textColor,
		},
		className: `toast-${type}`,
		classNames: {
			closeButton:
				"pointer-events-none rounded-md border border-white/90 bg-white/30 p-1 text-white shadow-sm opacity-0 transition hover:bg-white/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white group-hover:pointer-events-auto group-hover:opacity-100",
			actionButton:
				"rounded-md bg-white/90 px-2 py-1 text-xs font-medium text-black transition hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60",
		},
		...(duration && {
			duration,
		}),

		...(action && {
			action: {
				label: action.testId
					? createElement(
							"span",
							{ "data-testid": action.testId },
							action.label
						)
					: action.label,
				onClick: action.onClick,
			},
		}),
		...(description && {
			// Sonner greys out descriptions, which is unreadable on the coloured toasts.
			description: createElement(
				"span",
				{ style: { color: textColor, whiteSpace: "pre-line" } },
				description
			),
		}),
		closeButton: true,
	});
};
